module.exports = function () {
    if (!('MktoForms2' in window)) {
        return;
    }

    window._mfq = window._mfq || [];

    MktoForms2.onFormRender(function (form) {
        require('./setup-form-values')(form);
        require('./setup-form-submit')(form);
    });

    MktoForms2.whenReady(function (form) {
        require('./setup-form-display')(form);

        if (typeof (navigator) !== 'undefined' && ((typeof (navigator.userAgent) !== 'undefined' && navigator.userAgent.includes('HeadlessChrome') && navigator.userAgent.includes('Linux')) || (typeof (navigator.webdriver) !== 'undefined' && navigator.webdriver))) {
            form.submittable(false);
        }
    });
};